import { useAuth } from '../context/auth'
import { isUserExistsInGroup } from '../utils/userRights.ts'

export const usePanelUserRights = () => {
  const { state } = useAuth()
  const hasUserRights = isUserExistsInGroup(state.groups, 'dd_panel_users')
  const hasMainUserRights = isUserExistsInGroup(state.groups, 'dd_panel_main_users')

  return { hasUserRights, hasMainUserRights }
}
